// src/PrivacyPolicy.js
import React from 'react';

const PrivacyPolicyFusionTales  = () => {
  return (
    <div style={{
      color: '#002B32',
      backgroundColor: 'white',
      padding: '20px',
      width: '50%',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'left' // Align text to the left
    }}>
      <h1 style={{ textAlign: 'center' }}>Privacy Policy</h1>
      {/* Insert the rest of the privacy policy here, following the initial example */}
      <p>Welcome to Fusion Tales! We're committed to protecting your privacy and handling any personal information we obtain from you with care and respect. This Privacy Policy is designed to inform you about the types of information we might collect, how we use it, and the measures we take to ensure it's kept safe.</p>
      <h2 style={{ textAlign: 'left' }}>Information We Do Not Collect</h2>
      <p>"Fusion Tales " is designed to be enjoyed by people of all ages, including children under the age of 13. In keeping with our commitment to ensure the safety and privacy of our youngest players, we do not collect any personal information from our users. Our game does not require user registration, and we do not track or store any personal data that could be used to identify you or your device.</p>
      <h2 style={{ textAlign: 'left' }}>How We Ensure Your Privacy</h2>
      <p>Given our no-collection policy of personal information, there's no risk of your data being lost, misused, or altered. Our game is designed to be entirely safe for children and complies with the Children's Online Privacy Protection Act (COPPA), as well as other relevant privacy laws.</p>
      <h2 style={{ textAlign: 'left' }}>Changes to This Privacy Policy</h2>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top of this Privacy Policy. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
      <h2 style={{ textAlign: 'left' }}>Contact Us</h2>
      <p>If you have any questions about our privacy practices or this Privacy Policy, please contact us at:</p>
      <h3>Email: FusionTales mergemania@gmail.com</h3>
    </div>
  );
};

export default PrivacyPolicyFusionTales ;
